import React from "react";
import classes from "./InvestmentDetails.module.css";
import InvestmentChart from "./InvestmentChart/InvestmentChart";
import { Counter, Heading, Text } from "components/common";
import clsx from "clsx";

const InvestmentDetails = ({ positions }) => {
  console.log("positions", positions);
  let total_capital = positions?.reduce((acc, curr) => acc + parseInt(curr.capital), 0);

  let capital_where_status_is_active = positions?.filter((position) => position.status === "Active").reduce((acc, curr) => acc + parseInt(curr.capital), 0);





  return (
    <section className={classes.wrapper}>
    <InvestmentChart positions={positions} />
    </section>
  );
};

export default InvestmentDetails;
